import { z } from 'zod';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

const outputSchema = z.object({ value: z.string() });
const uiOptionsSchema = z.object({
  getOwnApps: z.boolean().optional().describe('allows to only get employee specific apps'),
  requireCostCenter: z.boolean().optional().default(true).describe('makes cost center mandatory'),
});

const makeFieldSchemaCompat = makeFieldSchema as any;

export const AppShortNamePickerSchema = makeFieldSchemaCompat({
  output: () => outputSchema,
  uiOptions: () => uiOptionsSchema,
});
